import React from 'react';
import PublicRoute from './services/auth/PublicRoute';
import ErrorBoundary from './component/errorBoundaryComponent/ErrorBoundary';

// Lazy load components
const Login = React.lazy(() => import('./views/pages/login/Login'));
const Register = React.lazy(() => import('./views/pages/register/Register'));
const CheckEmail = React.lazy(() =>
    import('./views/pages/forgetPassword/CheckEmail')
);
const CreatePassword = React.lazy(() =>
    import('./views/pages/forgetPassword/CreatePassword')
);
const PasswordReset = React.lazy(() =>
    import('./views/pages/forgetPassword/PasswordReset')
);
const SetupWelcome = React.lazy(() =>
    import('./views/pages/setepForm/SetupWelcome')
);
const PaymentPage = React.lazy(() =>
    import('./views/pages/setepForm/PaymentPage')
);
const AllSites = React.lazy(() =>
    import('./views/pages/sites/AllSites')
);
const SiteDetails = React.lazy(() =>
    import('./views/pages/sites/SiteDetails')
);
const SiteManagement = React.lazy(() =>
    import('./component/siteComponents/SiteManagement')
);
const UnitManagement = React.lazy(() =>
    import('./component/unitComponents/UnitManagement')
);
const Unit = React.lazy(() =>
    import('./views/pages/units/Unit')
);
const SettingPage = React.lazy(() =>
    import('./views/pages/settings/settings')
);
const OpportunityCalculator = React.lazy(() =>
    import('./views/pages/opportunityCalculator/OpportunityCalculator')
);
const SensorTesting = React.lazy(() =>
    import('./views/pages/sensors/SensorTesting')
);
const EnergyIntelligence = React.lazy(() =>
    import('./views/pages/energy/EnergyIntelligence')
);

const routes = [
    {
        path: '/',
        name: 'Login',
        element: (
            <PublicRoute>
                <ErrorBoundary>
                    <Login />
                </ErrorBoundary>
            </PublicRoute>
        ),
    },
    {
        path: '/register',
        name: 'Register',
        element: (
            <PublicRoute>
                <ErrorBoundary>
                    <Register />
                </ErrorBoundary>
            </PublicRoute>
        ),
    },
    {
        path: '/check-email',
        name: 'CheckEmail',
        element: (
            <PublicRoute>
                <ErrorBoundary>
                    <CheckEmail />
                </ErrorBoundary>
            </PublicRoute>
        ),
    },
    {
        path: '/create-password',
        name: 'CreatePassword',
        element: (
            <PublicRoute>
                <ErrorBoundary>
                    <CreatePassword />
                </ErrorBoundary>
            </PublicRoute>
        ),
    },
    {
        path: '/password-reset',
        name: 'PasswordReset',
        element: (
            <PublicRoute>
                <ErrorBoundary>
                    <PasswordReset />
                </ErrorBoundary>
            </PublicRoute>
        ),
    },
    {
        path: '/welcome',
        name: 'SetupWelcome',
        element: (
            <ErrorBoundary>
                <SetupWelcome />
            </ErrorBoundary>
        ),
    },
    {
        path: '/card-details',
        name: 'PaymentPage',
        element: (
            <ErrorBoundary>
                <PaymentPage />
            </ErrorBoundary>
        ),
    },
    {
        path: '/sites',
        name: 'AllSites',
        element: (
            <ErrorBoundary>
                <AllSites />
            </ErrorBoundary>
        ),
    },
    {
        path: '/site-management',
        name: 'SiteManagement',
        element: (
            <ErrorBoundary>
                <SiteManagement />
            </ErrorBoundary>
        ),
    },
    {
        path: '/unit-management',
        name: 'UnitManagement',
        element: (
            <ErrorBoundary>
                <UnitManagement />
            </ErrorBoundary>
        ),
    },
    {
        path: '/site/:siteId',
        name: 'SiteDetails',
        element: (
            <ErrorBoundary>
                <SiteDetails />
            </ErrorBoundary>
        ),
    },
    {
        path: '/site/:siteId/units',
        name: 'SiteUnits',
        element: (
            <ErrorBoundary>
                <SiteDetails />
            </ErrorBoundary>
        ),
    },
    {
        path: '/site/:siteId/settings',
        name: 'SiteSettings',
        element: (
            <ErrorBoundary>
                <SiteDetails />
            </ErrorBoundary>
        ),
    },
    {
        path: '/site/:siteId/energy',
        name: 'EnergyIntelligence',
        element: (
            <ErrorBoundary>
                <EnergyIntelligence />
            </ErrorBoundary>
        ),
    },
    {
        path: '/unit/:unitId',
        name: 'Unit',
        element: (
            <ErrorBoundary>
                <Unit />
            </ErrorBoundary>
        ),
    },
    {
        path: '/opportunity-calculator',
        name: 'OpportunityCalculator',
        element: (
            <ErrorBoundary>
                <OpportunityCalculator />
            </ErrorBoundary>
        ),
    },
    {
        path: '/settings',
        name: 'SettingsPage',
        element: (
            <ErrorBoundary>
                <SettingPage />
            </ErrorBoundary>
        ),
    },
    {
        path: '/sensor-testing',
        name: 'SensorTesting',
        element: (
            <ErrorBoundary>
                <SensorTesting />
            </ErrorBoundary>
        ),
    },
];

export default routes;